// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lkEEi","textarea":"styles_textarea__1Ltf4"};